module.exports = __webpack_public_path__ + "img/event_vm_free.8dc3219d.svg";